




































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CustomerImportIlustraSuccess extends Vue {
  @Prop({ default: '246' }) readonly width?: string;
  @Prop({ default: '232' }) readonly height?: string;
}
